export default __webpack_public_path__ + "static/media/jokenpo.66a74f86.png";